module.exports = __webpack_public_path__ + "static/media/amulet_01.7aa08cbb.png";